module.exports = __webpack_public_path__ + "science.wet-and-dry.car.dry.png?a83443a10667c98f411c224c7f3caa1d";